import { getWeek } from '@/lib/date-utils'
import DateCell from './date-cell'

const columnDate = (pid, country, drBaselines, pidForBaseline, costBaselines, profitBaselines, packageName = null) => ({
  id: 'date',
  header: 'Date',
  cell: ({ row, table }) => (
    <DateCell
      row={row}
      pid={pid}
      country={country}
      drBaselines={drBaselines}
      pidForBaseline={pidForBaseline}
      costBaselines={costBaselines}
      profitBaselines={profitBaselines}
      packageName={packageName}
      noteDates={table.options.meta?.noteDates}
    />
  ),
  enableHiding: false,
  filterFn: (row, columnId, filterValue) => {
    const data = row.original
    const date = data.date
    const [weekIndex] = getWeek(date)
    return weekIndex === Number(filterValue)
  },
  meta: {
    sticky: true,
    stickyLeft: 'left-[0px]',
  },
})

export default columnDate
